<form [formGroup]="sppConsumerDetailsForm" class="form-group" [class.spp-consumer-details-form-disabled]="readonly">
  <div formArrayName="contacts">
    <div class="form-container" *ngFor="let contact of contacts.controls; let i = index" [formGroupName]="i">
        <h6> 
          {{ formConfigList[i].formTitle }} #{{i+1}}
          <a 
            *ngIf="showEditBtn"
            class="edit-btn"
            [routerLink]="{cxRoute: 'cart'} | cxUrl"
            [queryParams]="{ sppFormEditForEntry: entryNumber }">
            <div class="edit-icon"></div>
           </a>
        </h6>
        <div class="row">
          <div *ngFor="let field of formConfigList[i].fields" class="col-md-6">
            <label class="label-content"> {{ field.displayName }} <span *ngIf="field.required && !readonly">*</span> </label>
            <input 
              *ngIf="field.type == 'String'"
              class="form-control"
              [formControlName]="field.code"
              [readonly]="readonly"
            />
            <cx-form-errors *ngIf="!readonly" [control]="getFormControl(i, field.code)"></cx-form-errors>
          </div>
        </div>
    </div>
  </div>
</form>